module.exports = __webpack_public_path__ + "img/map-driver-icon.c7ff3298.png";